import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

export const asModal = (WrappedComponent, opts = {}) =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {open: false};
      this.handleClick = this.handleClick.bind(this);
      this.handleEscKey = this.handleEscKey.bind(this);
      this.handleClickCloseButton = this.handleClickCloseButton.bind(this);
    }

    static defaultProps = {
      onClickModalClose: () => {},
    };

    className() {
      return classNames(
        'ds-modal _alignTop',
        opts.className,
        {_open: this.state.open},
        this.props.classNames,
      );
    }

    // when the component mounts, attach an event listener to the document
    // for closing the modal when the Esc key is pressed
    componentWillMount() {
      if (opts.override_esc_key) return;

      document.addEventListener('keydown', this.handleEscKey, false);
    }

    // when the compoent mounts, toggle state.open to true after 1ms. This
    // will cause the 'modal--open' call to be added to the modal. The
    // only reason for this is to allow for modal animations. Why not just
    // use a keyframe animation you say? Because this way we can tansition
    // both the containing '.modal' element AND the '.modal-window'
    // without having to define multiple keyframe animations. It also
    // allows us to easily define a slightly different exit animation.
    componentDidMount() {
      this.interval = setTimeout(() => {
        this.setState({open: true});
      }, 1);
    }

    // when the component unmounts, remove the Esc key event listener
    componentWillUnmount() {
      clearTimeout(this.interval);

      if (opts.override_esc_key) return;

      document.removeEventListener('keydown', this.handleEscKey, false);
    }

    handleEscKey(e) {
      if (e.keyCode === 27) {
        closeModal();
      }
    }

    handleClick(e) {
      if (e.target.classList.contains('ds-modal') && opts.backdrop) {
        closeModal();
      }
    }

    handleClickCloseButton() {
      const { onClose } = this.props;
      if (onClose) {
        onClose();
      }
      closeModal();
    }

    renderCloseLink() {
      if (opts.override_close) return;

      return (
        <button
          className="ds-btn -secondary --micro _icon _rounded _closeModal"
          onClick={this.handleClickCloseButton}
          data-testid="close-modal-button">
          <i className="materialIcon">close</i>
        </button>
      );
    }

    render() {
      return (
        <div
          className={this.className()}
          style={{'overflowY': 'scroll'}}
          data-backdrop={opts.backdrop}
          onClick={this.handleClick}>
          <div className="grid">
            <div className="ds-card">
              {this.renderCloseLink()}
              <WrappedComponent {...this.props} />
            </div>
          </div>
        </div>
      );
    }
  };

export const renderModal = ModalToRender => {
  ReactDOM.render(ModalToRender, document.querySelector('.modal-container'));
};

export const closeModal = () => {
  if (!document.querySelector('.ds-modal._open').classList) return;

  document.querySelector('.ds-modal._open').classList.remove('_open');
  setTimeout(function() {
    ReactDOM.unmountComponentAtNode(document.querySelector('.modal-container'));
  }, 500);
};



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/OldModal.js